import { configForLocale } from 'locale/messages';
import { HelpCenterArticle } from './consts';

export const INTERCOM_HELP_CENTER_BASE_URL = 'https://support.confirm.com';
export const ZENDESK_HELP_CENTER_BASE_URL = 'https://helpcenter.confirm.com/hc';

export const helpCenterArticleLink = (
  locale: string,
  article: HelpCenterArticle,
  unifiedIntercomEnabled: boolean = false
): string => {
  const { intercomLocale, zendeskLocale } = configForLocale(locale);

  if (unifiedIntercomEnabled && article.zendesk) {
    return `${ZENDESK_HELP_CENTER_BASE_URL}/${zendeskLocale}/articles/${article.zendesk}`;
  }

  return `${INTERCOM_HELP_CENTER_BASE_URL}/${intercomLocale}/articles/${article.intercom}`;
};
